import React, { useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, FormControl, MenuItem, Select, Typography } from "@mui/material"
import style from "./style";
import CustomInput from "../../../.././../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { addNewCustomerValidation } from "../../../../../helper/Validation";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";

const EditCustomerPage = ({handleEditCustomer, item}) => {

  const [mobile, setMobile] = useState(item?.phone.toString())
  const [cCode, setCCode] = useState(item?.cCode.toString())
  const options = countryList().getData();
  const mobileNumberRef = useRef();
  const navigate = useNavigate();
  const handleOnChanges = (value,country) => {
    setMobile(value);
    setCCode(country?.dialCode)
  };
  const handleEditCustomerData = async (data) => {
    handleEditCustomer(data,mobile,cCode);
  }
  const editCustomer = {
    name:{value:item?.name||"",error:"",focus:null},
    email:{value:item?.email||"",error:"",focus:null},
    phone:{value:item?.phone||"",error:"",focus:null},
    address:{value:item?.address||"",error:"",focus:null},
    city:{value:item?.city||"",error:"",focus:null},
    country:{value:item?.country||"",error:"",focus:null},
    zipCode:{value:item?.ZIPCode||"",error:"",focus:null},
    rewardPoint:{value:item?.reward||"",error:"",focus:null},

  }


  const { state, handleChange, handleSubmit, handleFocus, } = useForm(
    editCustomer,
    addNewCustomerValidation,
    handleEditCustomerData,
  );
  const { name, email, address, city, country, zipCode, rewardPoint } = state;

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Edit Customer</Typography>
        </Box>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container>
          <Grid item xs={12} lg={11.7} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Name<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  placeholder="Enter Name"
                  fullWidth
                  id="name"
                  error={name?.error}
                  name="name"
                  defaultValue={item?.name}
                  value={name?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="name"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Email<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  error={email?.error}
                  name="email"
                  placeholder="Enter Email"
                  defaultValue={item?.email}
                  value={email?.value}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="email"
                />
              </Box>
              <Box sx={style.inputBox}>
                <FormControl fullWidth sx={style.countryCode}>
                  <Typography sx={style.inputText}>
                    Phone<span style={{ color: "red" }}>*</span>
                  </Typography>
                  <PhoneInput
                    country={"za"}
                    enableSearch={true}
                    value={mobile}
                    defaultValue={cCode}
                    name="mobile"
                    onChange={(value, country) =>
                      handleOnChanges(value, country)
                    }
                    onFocus={handleFocus}
                    ref={mobileNumberRef}
                    sx={style.mobile}
                    inputProps={{
                      style: {
                        height: "1em",
                        borderRadius: "10px",
                        width: "100%",
                        marginTop: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Address</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="address"
                  placeholder="Enter Address"
                  error={address?.error}
                  name="address"
                  value={address?.value}
                  defaultValue={item?.address}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="address"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  City<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="city"
                  error={city?.error}
                  placeholder="Enter City"
                  name="city"
                  value={city?.value}
                  defaultValue={item?.city}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="city"
                />
              </Box>
              <Box sx={style.inputBox}>
                <FormControl fullWidth sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "2.8em",
                    marginTop: "0.5em",
                    borderRadius: "10px"
                  }
                }} >
                  <Typography shrink={true} sx={style.inputText}>Country <span style={{ color: "red" }}>*</span></Typography>                                
                  <Select
                    value={country.value || item?.country}
                    onChange={(event) => { handleChange("country", event.target.value)}}
                    name="country"
                    sx={style.dropDownMenu}
                    onFocus={handleFocus}
                    error={country.error}
                    displayEmpty
                  >
                    <MenuItem disabled value="">Select</MenuItem>
                    {options.map((country, index) => (                       
                      <MenuItem key={index} sx={style.dropDownMenu} value={country.label}>{country.label}</MenuItem>
                    ))}                              
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Zip Code<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="zipCode"
                  placeholder="Enter Zip Code"
                  error={zipCode?.error}
                  name="zipCode"
                  value={zipCode?.value}
                  defaultValue={item?.ZIPCode}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  autoComplete="zipCode"
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Reward Points</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  type="number"
                  id="rewardPoint"
                  error={rewardPoint?.error}
                  placeholder="Reward Points"
                  name="rewardPoint"
                  value={rewardPoint?.value}
                  defaultValue={item?.reward}
                  inputProps={{ min: 0 }}
                  onChange={(e, val) => {
                    const positiveValue = Math.max(0, Number(val));
                    handleChange("rewardPoint", positiveValue);
                  }}
                  onFocus={handleFocus}
                  autoComplete="rewardPoint"
                />
              </Box>
              <Box sx={style.inputBox}></Box>
            </Box>
          </Grid>

          <Box sx={style.mainBoxes}>
            <Box sx={style.createJob}>
              <Button
                variant="contained"
                type="submit"
                color="success"
                sx={style.jobButtons}
                disabled={!name?.value || name?.error || !email?.value || email?.error || !mobile || !cCode || !city?.value || city?.error || !country?.value || country?.error || !zipCode?.value || zipCode?.error}
              >
                Update Changes
              </Button>
            </Box>

            <Box sx={style.createJob}>
              <Button
                variant="contained"
                onClick={() => navigate("/dashboard/customer")}
                color="success"
                sx={style.cancelButtons}
              >
              Cancel
              </Button>
            </Box>
          </Box>
        </Grid>
      </form>
    </>
  )
}
export default EditCustomerPage;
